import React from 'react';
import PropTypes from 'prop-types';

const Label = ({ name }) => {
    return (
        <div className="input-group-prepend">
            <div className="input-group-text">{name}</div>
        </div>
    );
}

Label.propTypes = {
    name: PropTypes.string.isRequired
}


export default Label;